// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.xsveQKthk7XxY6 {
  position: relative;
  width: 64px;
  height: 64px;
  margin: var(--ds-space-075, 6px);
  cursor: grab;
}
.Os2jZrPChmPCou {
  position: absolute;
  top: var(--ds-space-0, 0);
  left: var(--ds-space-0, 0);
  width: 64px;
  height: 64px;
  backface-visibility: hidden;
  clip: rect(0 32px 64px 0);
}
.Os2jZrPChmPCou[data-drag-preview] {
  position: static;
  clip: auto;
  backface-visibility: visible;
}
.CTbfcUwNJw4j3z {
  position: absolute;
  top: var(--ds-space-0, 0);
  left: var(--ds-space-0, 0);
  width: 64px;
  height: 64px;
  backface-visibility: hidden;
  clip: rect(0 64px 64px 32px);
  transform: scaleX(1) skewY(0deg);
  transition: transform 0.25s ease;
  opacity: 0.1;
  filter: brightness(0);
}
.Kof9Bk39oF4wE9 .CTbfcUwNJw4j3z {
  transform: scaleX(0.95) skewY(8deg);
}
.o7Qypv7njet_8L {
  position: absolute;
  top: var(--ds-space-0, 0);
  left: var(--ds-space-0, 0);
  width: 64px;
  height: 64px;
  backface-visibility: hidden;
  clip: rect(0 64px 64px 32px);
  transform: perspective(300px);
  transform-style: preserve-3d;
  transition: transform 0.2s ease;
}
.Kof9Bk39oF4wE9 .o7Qypv7njet_8L {
  transform: perspective(300px) rotateY(-50deg);
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"sticker": `xsveQKthk7XxY6`,
	"fixed": `Os2jZrPChmPCou`,
	"shadow": `CTbfcUwNJw4j3z`,
	"isPeeling": `Kof9Bk39oF4wE9`,
	"peel": `o7Qypv7njet_8L`
};
export default ___CSS_LOADER_EXPORT___;
